import { z } from "zod";

import { defineEvents } from "~/analytics/factory";

export const events = defineEvents("advertising", {
  campaign_created: z.object({
    campaign_id: z.string(),
    campaign_type: z.string(),
    account_id: z.string(),
  }),
  campaign_archived: z.object({
    campaign_id: z.string(),
    account_id: z.string(),
  }),
  campaign_cloned: z.object({
    campaign_id: z.string(),
    account_id: z.string(),
  }),
});

export type Events = typeof events;
